import Vue from 'vue'
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import BootstrapVueTreeview from 'bootstrap-vue-treeview'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/custom.css'

import App from '@/App.vue'
import Login from '@/components/Login.vue'
import MainPage from '@/components/MainPage.vue'
import About from '@/components/About.vue'
//import Overview from '@/components/Overview.vue'
import Datasets from '@/components/Datasets.vue'
import Userguide from '@/components/Userguide.vue'
import { store } from '@/store.js'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueTreeview)
Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(VueRouter)

// setup Vue router
const routes = [
    { path: '/', component: MainPage },
    { path: '/login', component: Login },
    { path: '/about', component: About },
    //{ path: '/overview', component: Overview },
    { path: '/datasets', component: Datasets },
    { path: '/userguide', component: Userguide }
]

const router = new VueRouter({
    routes
})

new Vue({
    router: router,
    store: store,
    render: h => h(App),
}).$mount('#app')
